import React from "react";
import "../style/floorAndLounges.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";
import FloorAndLoungesSingleCard from "./FloorAndLoungesSingleCard";

export default function FloorAndLounges() {
  const ground = {
    img: "../assets/floor-ground.jpg",
    name: "Bangaliyana Lounge",
    description: "Mordern Interior Mixed with asthetic vibe",
  };

  const first = {
    img: "../assets/floor-first.jpg",
    name: "Prime Lounge",
    description: "Modern interior with best food experience",
  };

  const second = {
    img: "../assets/floor-second.jpg",
    name: "Velvet Lounge",
    description:
      "Thoughtfully designed for making your special moment extra special",
  };

  const banquet = {
    img: "../assets/floor-banquet.jpg",
    name: "Bada Boudi Banquet",
    description: `For your party and special occasions`,
  };

  const mocktail = {
    img: "../assets/floor-mocktail.jpg",
    name: "Mocktail Counter",
    description: `Situated in both Prime and Velvet Lounge`,
  };
  return (
    <div className="main">
      <div className="container1">
        <h1>Floor & Lounges</h1>
      </div>
      <div style={{ padding: "20px 60px" }}>
        <Swiper
          slidesPerView={3}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          modules={[Pagination]}
          className="mySwiper"
        >
          <SwiperSlide>
            <FloorAndLoungesSingleCard content={ground} />
          </SwiperSlide>
          <SwiperSlide>
            <FloorAndLoungesSingleCard content={first} />
          </SwiperSlide>
          <SwiperSlide>
            <FloorAndLoungesSingleCard content={second} />
          </SwiperSlide>
          <SwiperSlide>
            <FloorAndLoungesSingleCard content={banquet} />
          </SwiperSlide>
          <SwiperSlide>
            <FloorAndLoungesSingleCard content={mocktail} />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}
